<!-- PDF-Sub-header -->
<div class="pdf-report-container">
  <ng-content select="[sub-header]"></ng-content>
</div>
@if (!isNonTableView) {
  <!-- PDF-Body -->
  <table
    [ngClass]="['pdf-report-table', tableFontClass]"
  >
    <caption>
      Pdf Report Generator
    </caption>
    <tr class="pdf-report-header-row">
      @for (column of columns; track column; let i = $index) {
        <th
          class="pdf-report-header-cell"
          [attr.width]="getColWidth(i)"
        >
          {{ column }}
        </th>
      }
    </tr>
    @for (columnData of columnsData; track columnData) {
      <tr [attr.height]="dataRowHeight">
        @for (field of dataFields; track field; let i = $index) {
          <td
            [ngClass]="['pdf-report-data-cell', dataCellFontClass]"
            [attr.width]="getColWidth(i)"
          >
            {{ columnData[field] }}
          </td>
        }
      </tr>
    }
    @if (hasTotalRow) {
      <ng-content select="[total-row]"></ng-content>
    }
  </table>
  <ng-content select="[total]"></ng-content>
} @else {
  <ng-content select="[custom-report]"></ng-content>
}
